var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tutorBox"},[_c('img',{staticClass:"courseTutor",attrs:{"src":_vm.cover,"alt":""},on:{"click":function($event){return _vm.enterDetails()}}}),_c('div',{staticClass:"goCourse",on:{"click":function($event){return _vm.enterDetails()}}},[_vm._v("前往了解课程")])])
}
var staticRenderFns = []

export { render, staticRenderFns }